import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { GradeService } from '../_services/grades.service';
import { StaffService } from '../_services/staff.service';
import { InfoService } from '../_services/info.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import moment from 'moment';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { Subject, takeUntil } from 'rxjs';
import { TimeZoneService } from 'src/app/_services/time-zone.service';
import { extractFlowStages, getGradeIssues, GradeIssues } from '../_model/grade-issues';


declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-grade-class-card',
  templateUrl: './grade-class-card.component.html',
  styleUrls: ['./grade-class-card.component.scss']
})
export class GradeClassCardComponent implements OnInit {
  @Input() grade;
  @Input() gradeIndex;
  grades=[];
  gates = [];
  supervisors = [];
  classes = [];
  teachers = [];
  students = [];
  cardError = false;
  cardWarning = false;
  issues: GradeIssues = {
    gate: false, supervisors: false, teachers: false, flow: false,
    criticalKeys: [], warningKeys: [], keys: [], hasCritical: false, hasWarning: false, hasError: false
  };
  flowSteps: string[] = [];
  /** how many people are named before the rest roll up into "+N more" */
  chipsLimit = 3;
  formattedDate;
  supervisorsErrors = false;
  gatesErrors = false;
  teachersErrors = false;
  teachersErrorsResult = [];
  hintShow = false;
  school_closing_time;
  current_time;
  // min_Pickup_Time;
  starting_pickup_Time;
  formated_closing_time;
  today_name;
  currLang;
  dismissalStartedFlag=false;
  destroy$ = new Subject<void>(); 
  constructor(
    private gradesService: GradeService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private staffService: StaffService,
    private infoService: InfoService,
    private dataService: DataService,
    private controlDeletion: ControlDeletionService,
    private amplitudesService: AmplitudeService,
    private timeZoneService:TimeZoneService,
    private router: Router) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)grade-class-card_(f)getLang_(L)58' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      //console.log('(c)grade-class-card_(f)getLang_(L)66' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.gates = this.grade.gates;
    this.supervisors = this.grade.supervisors;
    this.classes = this.grade.school_classes;
    this.classes.map(oneClass => {
      this.teachers = [...this.teachers, ...oneClass.teachers]
    })
    this.classes.map(oneClass => {
      this.students = [...this.students, ...oneClass.students]
    })
    this.flowSteps = extractFlowStages(this.grade?.flow?.name);
    // a missing gate / teacher / flow blocks dismissal and turns the card red ,
    // a missing supervisor only earns an amber note
    this.issues = getGradeIssues(this.grade);
    this.supervisorsErrors = this.issues.supervisors;
    this.gatesErrors = this.issues.gate;
    this.teachersErrors = this.issues.teachers;
    this.cardError = this.issues.hasCritical;
    this.cardWarning = this.issues.hasWarning;
  }

  /** the flow is assigned from the dismissal flow tab , not from the grade modal */
  goToDismissalFlow() {
    this.router.navigate(['school-management/dismissal-flow']);
  }

  /** 'R' | 'P' | 'T' | 'S' | 'G' -> the translate key of the flow stage */
  flowStageKey(stage: string) {
    const stages = {
      R: 'request',
      P: 'parent',
      T: 'teacher',
      S: 'supervisor',
      G: 'guard'
    };
    return `dismissal-flow.${stages[stage] || 'request'}`;
  }
  
  editGrade(gradeId, index, checkDismissalStarted) {
    this.amplitudesService.trackEvent('CTA.Edit_Grade',{})
    switch (checkDismissalStarted) {
      case false:
        this.gradesService.getGrade(gradeId).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
          //console.log('(c)grade-class-card_(f)editGrade_(L)93' , res);
          if(res){
            this.gradesService.setGradeData(res);
            $("#addGradeModal").modal("show");
          }
        })
        break;
      case true:
        // get all grades from global service
        // this.globalService.getAllGrades().pipe(takeUntil(this.destroy$)).subscribe(grades =>{
        //   this.grades=grades
        //   //  filter pickup start time of grades and return values != null
        //   this.grades= this.grades.filter(grade=> grade.pickup_start_time !== null);
        //   //  using reduce to return the grade that has the minimum time of all start up times 
        //   this.grades= this.grades.reduce(function(prev, curr) {
        //   return prev.pickup_start_time < curr.pickup_start_time ? prev : curr;
        // });
        // // assigning the min start up time from the grade to a predefined property called min_Pickup_Time
        // this.min_Pickup_Time=this.grades['pickup_start_time'];
        //   // console.log(this.min_Pickup_Time)
        // });

        // calling a method that gets the current time 
        this.getTime();
        //get which day of week is today 
        this.today_name = moment(new Date()).format('dddd');
        // getting the school ending time by calling school info api
        this.dataService.getSchoolInfo().pipe(takeUntil(this.destroy$)).subscribe(res => {
          let selectedSchool;
          selectedSchool = res.find(school => school.selected == true);
          this.school_closing_time = this.timeZoneService.convertToLocalTime(selectedSchool.school_closing_time , "HH:mm:ss" , "HH:mm:ss");
          if (this.school_closing_time != null) {
            this.convert12Format(this.school_closing_time);
          }
          // getting the grade starting pickup time by calling grade api
          this.gradesService.getGrade(gradeId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
            res.gradIndex = index;
            // get the day from dismissal_schedule that match todays date 
            if (res.dismissal_schedule.length > 0) {
              let selectedDay = res.dismissal_schedule.find(day => day.day_of_week == this.today_name)
              this.starting_pickup_Time = this.timeZoneService.convertToLocalTime(selectedDay.start_time , "HH:mm" , "HH:mm");
            }
            // check if school has an ending time to begin with
            // console.log(this.starting_pickup_Time , this.current_time , this.school_closing_time);
            if (this.school_closing_time != null) {
              // checking dismissal started for each grade seperated 
              if (this.starting_pickup_Time < this.current_time && this.current_time < this.school_closing_time) {
                this.dismissalStartedFlag = true;
              }
              // dismissal period isn't on , user can open the modal and edit grade 
              else {
                this.dismissalStartedFlag = false;
                this.gradesService.setGradeData(res);
                $("#addGradeModal").modal("show");
              }
            }
            else {
              this.gradesService.setGradeData(res);
              $("#addGradeModal").modal("show");
            }


            setTimeout(() => {
              $(".dismissal-alert").hide("slow", "swing");
              // switch the flag back to false , other wise it will still true and error will only show the first time 
              this.dismissalStartedFlag = false;
            }, 8000);
          })

          /* check if the current time is bigger than the min grade starting pickup time
        and less than the school ending time , that means that shcool dismissal 
        period is on , and user can't edit grade during this period.
         */
          // if(this.min_Pickup_Time < this.current_time  && this.current_time < this.school_closing_time){
          //   this.dismissalStartedFlag = true;
          // }
          // // dismissal period isn't on , user can open the modal and edit grade 
          // else{
          //   this.dismissalStartedFlag = false;
          //   this.gradesService.getGrade(gradeId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          //     this.gradesService.setGradeData(res);
          //     $("#addGradeModal").modal("show");
          //   })
          // }
        });
        // hide the error message after 3 seconds
        break;

    }
  }

  deleteGrade() {
    let body = { 'type': 'grades', 'grade': this.grade }
    this.controlDeletion.setDeletedRows(body)
    $("#deleteModal").modal("show");
    this.amplitudesService.trackEvent('CTA.Delete_Grade',{})
  }

  openClassListing(clazz) {    
    this.gradesService.setClassData(clazz);
    $("#classListing").modal("show");
  }

  addStaff() {
    this.staffService.setStaffData(null, 'add');
    $("#addStaffModal").modal("show");
  }

  openSupervisor(supervisor) {
    this.staffService.getStaffById(supervisor.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.staffService.setStaffData(res, 'view');
      $("#addStaffModal").modal("show");
    })
  }

  openTeacher(teacher) {
    this.staffService.getStaffById(teacher.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.staffService.setStaffData(res, 'view');
      $("#addStaffModal").modal("show");
    })
  }
  getTime(){
    var now = new Date();
    // now.setHours(now.getHours() + 1); add if you want ksa timming 
   var hours = ('0'+ now.getHours()).slice(-2);
   var mins = ('0'+ now.getMinutes()).slice(-2);
   var sec = ('0'+ now.getSeconds()).slice(-2);
   this.current_time = `${hours}:${mins}:${sec}`;
  //  console.log(this.current_time)
  }

  convert12Format(time){
    let pm: string;
    let am: string;
    switch (this.currLang) {
      case 'en':
        pm='PM'
        am='AM'
        break;
      case 'ar':
        pm='م'
        am='ص'
        break;
    }
    var timeString = time;
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = (H < 12 || H === 24) ? am : pm;
    timeString = h + timeString.substr(2, 3) + " " + ampm;
    this.formated_closing_time=timeString;
  }

  openReorderClassesModal(classes:any){
    let sendClasses = [...classes]; // Create a shallow copy of the classes array to not refrence the original classes
    this.gradesService.setClassesForReorder(sendClasses);
    $("#classReorderModal").modal('show');
  }

  ngOnDestroy(): void {
  }
}
